module.exports = __webpack_public_path__ + "assets/images/extra_lady3.cbd127ad885f988db3a448b354c510d3.svg";